export default __webpack_public_path__ + "static/media/card1.5e593f24.png";